import React from 'react';
import ModalBackground from './ModalBackground';

export function Modal({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div className="purchase-modal-overlay" onClick={onClose}>
      <div className="purchase-card visible">
        <div className="purchase-modal-sheet visible" onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    </div>
  );
}

Modal.Header = function ModalHeader({ title, onClose }) {
  return (
    <div className="purchase-modal-header" style={{ position: 'relative', overflow: 'visible' }}>
      <ModalBackground />
      <h2 className="purchase-modal-title" style={{ position: 'relative', zIndex: 1 }}>{title}</h2>
      <img
        className="purchase-modal-close"
        src="/close.png"
        alt="Close"
        onClick={onClose}
        style={{ position: 'absolute', zIndex: 1 }}
      />
    </div>
  );
};

Modal.Body = function ModalBody({ children, className }) {
  return <div className={`purchase-modal-content ${className || ''}`}>{children}</div>;
};

Modal.Footer = function ModalFooter({ children }) {
  return <div className="purchase-modal-buttons">{children}</div>;
};

export default Modal;


